import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as moment from 'moment';
import formatAmount from '../shared/format_amount';

class ProductDetails extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
  };

  renderSku = () => {
    if (this.props.product.sku) {
      return <p className="mb-0">{I18n.t('js.productBundles.productDetails.sku', { sku: this.props.product.sku })}</p>;
    }
  };

  renderCost = () => {
    if (this.props.product.seller_cost) {
      return <p className="mb-0">{I18n.t('js.productBundles.productDetails.sellerCost', { cost: formatAmount(this.props.product.seller_cost) })}</p>;
    }
  };

  renderPrice = () => {
    if (this.props.newPrice !== undefined) {
      return (
        <div>
          <h4 className="heading-4"><strike>{formatAmount(this.props.product.original_price)}</strike></h4>
          <h4 className="heading-4">{formatAmount({ amount: this.props.newPrice, symbol: this.props.product.price.symbol })}</h4>
        </div>
      );
    }
    return <h4 className="heading-4">{formatAmount(this.props.product.price)}</h4>;
  };

  render() {
    return (
      <div className="g-container">
        <div className="g-col-3 g-col-mobile-2">
          <a href={this.props.product._links.web.href} target="_blank" rel="noopener noreferrer">
            <img className="img-wide" alt={this.props.product.title} src={this.props.product._links.photo.href} />
          </a>
        </div>
        <div className="g-col-7 g-col-mobile-8">
          <h4 className="heading-4">
            <a
              href={this.props.product._links.web.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.props.product.title}
            </a>
          </h4>
          {this.renderSku()}
          <p className="mb-0">{I18n.t('js.productBundles.productDetails.condition', { condition: this.props.product.condition.display_name })}</p>
          {this.renderCost()}
          <p className="mb-0">{moment(this.props.product.created_at).fromNow()}</p>
        </div>
        <div className="g-col-2 align-right">
          {this.renderPrice()}
        </div>
      </div>
    );
  }
}

export default ProductDetails;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_details.jsx